import iconComponents from '@/assets/icons/iconComponents'
import React from 'react'
import Typography from '../Typography'
import clsx from 'clsx'

type IModalHeader = {
  onClose?: () => void
  title?: React.ReactNode
  subText?: React.ReactNode
  titlePosition?: 'left' | 'center'
}
const ModalHeader = (props: IModalHeader) => {
  const { onClose, title, subText, titlePosition = 'left' } = props
  const isCentered = titlePosition === 'center'
  return (
    <header className='flex flex-col justify-start items-start w-full pb-6'>
      <div
        className={clsx(
          'w-full flex items-center',
          isCentered
            ? 'justify-center relative min-h-[40px]'
            : 'justify-between'
        )}
      >
        <Typography
          as='h4'
          className={clsx('text-jaa-shades-black', isCentered && 'text-center')}
        >
          {title}
        </Typography>
        {onClose && (
          <button
            onClick={onClose}
            className={clsx(
              'p-1 rounded-sm hover:bg-[#f7f7f7] active:bg-[#f7f7f7] w-[28px] h-[28px] sm:w-[37px] sm:h-[37px]',
              isCentered && 'absolute right-0'
            )}
          >
            <iconComponents.util.CancelIcon
              width={24}
              height={24}
              stroke='var(--shades-black)'
            />
          </button>
        )}
      </div>
      {subText && (
        <Typography
          as='p'
          className='text-jaa-shades-gray-2.5 sm font-normal pr-8'
        >
          {subText}
        </Typography>
      )}
    </header>
  )
}

export default ModalHeader
